// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1McWX","itemTitle":"ClientEmergencyInfo_itemTitle__3dgsj","itemText":"ClientEmergencyInfo_itemText__1MUIl"};